// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","body":"EmailUpdatesPanel_body__+wuYb","question":"EmailUpdatesPanel_question__yDGJj","form":"EmailUpdatesPanel_form__1tO0a"};